import { useEffect } from 'react';
import useConfirmation from './useConfirmation';
import { registerNavigationConfirmation } from './navigationConfirmationBridge';

export default function NavigationConfirmationHost() {
  const { confirm, confirmation } = useConfirmation();
  useEffect(() => registerNavigationConfirmation(confirm), [confirm]);
  return confirmation;
}
